import { createFileRoute } from "@tanstack/react-router";
import { MarketingContentPage } from "../components/marketing/MarketingContentPage";
import { contentHead, loadContentPage } from "../marketing-content/load";

export const Route = createFileRoute("/changelog_/$slug")({
  loader: ({ params }) => loadContentPage(`/changelog/${params.slug}`),
  head: ({ loaderData }) => contentHead(loaderData),
  component: ContentRoute,
});
function ContentRoute() {
  return <MarketingContentPage page={Route.useLoaderData()} />;
}
